export default {
  tr: {
    academic: "Akademik",
    actions: 'İşlemler',
    active: "Aktif",
    allHatTypes: "Tüm Hat Türleri",
    apostille_translation: "Apostil Tasdikli Çeviri",
    back: "Geri",
    cancel: 'İptal',
    close: 'Kapat',
    complete: 'Tamamla',
    completeJob: 'İşi Tamamla',
    completed: "Tamamlanan",
    completionFailed: 'Tamamlama işlemi başarısız.',
    confirmDelete: 'Bu dosyayı silmek istediğinize emin misiniz?',
    customer: "Müşteri",
    delete: 'Sil',
    deleteFailed: 'Silme işlemi başarısız.',
    delivery: "Teslim",
    deliveryDate: 'Teslim Tarihi',
    deliveryNearest: "Teslim Tarihi Yakın",
    delivery_date_label: "Ne Zaman Teslim Edilsin?",
    desc: "Açıklama",
    description: 'Açıklama',
    details: "İş Detayları",
    document_description: "Belge adı veya açıklama",
    edit: 'Düzenle',
    email: "E-posta",
    file: 'Dosya',    
    fileDeleted: 'Dosya silindi.',
    filenameAsc: "Dosya A-Z",
    filenameDesc: "Dosya Z-A",
    general: "Genel",
    hatType: "Hat Türü",    
    jobCode: "İş Kodu",    
    jobCompleted: 'İş başarıyla tamamlandı.',
    job_code: "İş Kodu",
    jobs: 'İşler',
    langPlaceholder: "Dil ara...",
    langs: "Diller",
    language: 'Dil',
    legal: "Hukuki",
    loading: 'Yükleniyor...',
    medical: "Medikal",
    new_translation_request: "Yeni Çeviri Talebi Oluştur",
    next: "İleri",
    noData: 'Veri bulunamadı',
    noFileSelected: 'Dosya seçilmedi.',
    noOutputYet: 'Henüz Yok',
    none: "Yok",
    notary_translation: "Noter Tasdikli Çeviri",
    offer: "Teklif Ver",
    official_document_translation: "Resmi Belge Çeviri",
    openJobs: "Açık İşler",
    outputFile: 'Çıktı Dosyası',
    outputUploaded: 'Çıktı dosyası yüklendi.',
    outputs: 'Çıktılar',
    page: "Sayfa",
    paid: "Ödendi",
    pay_now: "Ödeme Yap",
    payment: 'Ödeme',
    pending: "Beklemede",
    price: 'Fiyat',
    priceAsc: "Fiyat Artan",
    priceDesc: "Fiyat Azalan",
    request_revision: "Revizyon Talep Et",
    searchPlaceholder: "İş veya Müşteri ara...",
    selectSourceLang: 'Kaynak Dili Seçin',
    selectTargetLang: 'Hedef Dili Seçin',
    select_calligraphy_type: "Hat Türü Seçin",
    select_source_language: "Kaynak Dili Seçin",
    select_specialization: "Uzmanlık Alanı Seçin",
    select_target_language: "Hedef Dili Seçin",
    select_translation_type: "Çeviri Türü Seçin",
    sortNone: "Sıralama Yok",
    specialization: "Uzmanlık",
    submit: 'Gönder',
    submitOffer: "Teklifi Gönder",
    sworn_translation: "Yeminli Çeviri",
    technical: "Teknik",
    translationType: "Tercüme Türü",    
    translator: 'Tercüman',
    upload: 'Yükle',
    uploadDocument: 'Belgeyi Yükle',
    uploadFailed: 'Yükleme başarısız.',
    uploadTime: 'Yüklenme Zamanı',
    upload_document: "Belgeyi Yükle",
    welcome: 'Hoş geldiniz',
    your_jobs: "Mevcut İşleriniz",

  status: {
    title: 'İş Durumları',
    waiting: 'Beklemede',
    inProgress: 'Devam Ediyor',
    completed: 'Tamamlandı',
    waitingForPayment: 'Ödeme Bekliyor',
    paymentReceived: 'Ödeme Alındı',
    revisionRequested: 'Revizyon Talep Edildi',
    assigned: 'Atandı',
  },
  nav: {
    home: 'Anasayfa',
    about: 'Hakkımızda',
    contact: 'İletişim',
    translators: 'Tercümanlarımız',
    login: 'Giriş',
    logout: 'Çıkış',
    panel: 'Panel',
    settings: 'Ayarlar',
    apply: "Tercüman Başvurusu",
    quote: "Çeviri Teklifi",
    services: "Hizmetlerimiz",
    official: "Resmi Belge Çeviri",
    sworn: "Yeminli Çeviri",
    notary: "Noter Tasdikli Çeviri",
    apostille: "Apostil Tasdikli Çeviri",
    welcome: "Hoş geldiniz, yönlendiriliyorsunuz...",
    warning: "Bu sayfada sadece kullanıcılar çeviri için teklif alabilir. Çeviri teklifinde bulunmak için kullanıcı kaydı oluşturun.",
  },

  translatorPanel: {
    welcome: 'Hoş Geldiniz, {name}!',
    tabs: {
      assigned: 'Atanan İşler',
      open: 'Açık İşler',
      offered: 'Teklif Verdiklerim',
      completed: 'Tamamlanan İşler'
    },
    table: {
      jobCode: 'İş Kodu',
      file: 'Dosya',
      desc: 'Açıklama',
      deliveryDate: 'Teslim Tarihi',
      outputFile: 'Çıktı Dosyası',
      uploadTime: 'Yüklenme Zamanı',
      customer: 'Müşteri',
      actions: 'İşlemler',
      specialization: 'Uzmanlık',
      edit: 'Düzenle',
      completeJob: 'İşi Tamamla',
      delete: 'Sil',
      noOutputYet: 'Henüz Yok'
    },
    loading: 'Yükleniyor...',
  },   

  assignedJobs: {
    title: 'Atanan İşler'
  },    
  hero: {
    title1: "Dil Bariyerlerini Aşın",
    title2: "Profesyonel Çeviri Hizmeti",
    title3: "Güvenilir ve Hızlı Teslimat",
    title4: "Belgeleriniz Bizimle Güvende",
    subtitle: 'Profesyonel tercümanlarla güvenilir ve hızlı çeviri hizmeti alın.',
    subtitle2: 'Her dilde uzman tercümanlarımızla tanışın.',
    subtitle3: "Zamanında, kaliteli ve uygun fiyatlı çeviriler.",
    subtitle4: "Belgeleriniz gizli ve güvende tutulur.",
    contactButton: "İletişime Geç"
  },
  services: {
    title: "Hizmetlerimiz",

  official: {
    title: "Resmi Belge Çeviri",
    description: "Resmi belgeleriniz (pasaport, diploma, kimlik vb.) uzman çevirmenlerimiz tarafından hukuki ve resmî uygunluk çerçevesinde çevrilir. Belgelerinizin resmî kurumlar tarafından kabul edilmesini garanti altına alıyoruz.",
    button: "Belge Ver"
  },

  sworn: {
    title: "Yeminli Çeviri",
    description: "Yeminli tercüme, mahkemelerce yetkilendirilmiş tercümanlar tarafından yapılan ve imzalanıp kaşelenmiş çevirilerdir. Resmî işlemlerde geçerlidir. Belgeleriniz hukuken bağlayıcı biçimde çevrilir.",
    button: "Belge Ver"
  },

  notary: {
    title: "Noter Tasdikli",
    description: "Yeminli tercüman tarafından çevrilen belge, noter onayına sunularak resmiyet kazanır. Bu hizmet özellikle yurt içindeki resmî başvurularda tercih edilir.",
    button: "Belge Ver"
  },

  apostille: {
    title: "Apostil Tasdikli",
    description: "Apostil, yurtdışında geçerlilik için gereken uluslararası tasdik sistemidir. Belgeniz önce çevrilir, ardından noter ve kaymakamlık üzerinden apostil şerhi alınır.",
    button: "Belge Ver"
  },

  revision: {
    title: "İş Revizesi",
    description: "Çevirinizde eksiklik veya hata olması durumunda ücretsiz revize talep edebilirsiniz. Müşteri memnuniyetini garanti altına alıyoruz.",
    button: "Revize Talep Et"
  },

  notifications: {
    title: "Bildirim Desteği",
    description: "İş sürecinizdeki her adımdan anında haberdar olun. Bildirimleri açarak teklif, onay, teslim gibi tüm aşamaları kolayca takip edin.",
    button: "Bildirimleri Aç"
   }  
  },

  howItWorks: {
    title: 'Nasıl Çalışır?',
    upload: 'Belgeni Yükle',
    uploadDesc: 'Çevirmek istediğin belgeyi sistemimize yükle.',
    offer: 'Teklif Al',
    offerDesc: 'Tercümanınızdan gelen teklifi gör.',
    pay: 'Ödeme Yap',
    payDesc: 'Ödemeni gerçekleştir.',
    receive: 'Teslim Al',
    receiveDesc: 'Çevirin hazır olduğunda indir.'
  },
  testimonials: {
    title: "Müşteri Yorumları",
    comment1: "Hizmet çok hızlı ve kaliteliydi. Belgemi zamanında teslim aldım. Kesinlikle tekrar çalışacağım.",
    name1: "Ahmet Yılmaz",
    comment2: "Belgemi aynı gün çevirdiler. İletişim çok kolaydı ve süreç sorunsuz ilerledi.",
    name2: "Elif Demir",
    comment3: "Fiyat-performans açısından oldukça başarılı bir hizmet aldım. Tavsiye ederim.",
    name3: "Burak K.",
    comment4: "İlgili müşteri desteği ve kaliteli çeviri hizmeti için çok teşekkür ederim.",
    name4: "Zeynep A."
  },
  footer: {
    contact: "İletişim",
    chat: "Bizimle sohbet edin",
    services: "Hizmetlerimiz",
    service1: "Resmi Belge Çeviri",
    service2: "Yeminli Çeviri",
    service3: "Noter Tasdikli Çeviri",
    service4: "Apostil Tasdikli Çeviri",
    service5: "Çeviri Teklifi",
    company: "Şirket",
    about: "Hakkımızda",
    careers: "Kariyer",
    social: "Sosyal Medya",
    rights: "Tüm hakları saklıdır"
  },
  register: {
    title: 'Kayıt Ol',
    name: 'Adınız',
    surname: 'Soyadınız',
    birthDate: 'Doğum Tarihiniz',
    phone: 'Telefon Numaranız',
    email: 'E-posta',
    password: 'Şifre',
    passwordRule: 'Şifre en az 8 karakter, büyük/küçük harf, sayı ve sembol içermelidir.',
    agreeText: '<terms>Kullanıcı Sözleşmesini</terms> ve <privacy>Gizlilik Politikasını</privacy> kabul ediyorum.',
    terms: 'Kullanıcı Sözleşmesi',
    privacy: 'Gizlilik Politikası',
    termsText: 'kabul ediyorum.',
    privacyText: 'kabul ediyorum.',
    alreadyHaveAccount: 'Zaten hesabınız var mı?',
    registerButton: 'Kayıt Ol',
    goLogin: 'Giriş Yap',
    mustBeOver18: '18 yaşından büyük olmalısınız.',
    invalidPhone: 'Lütfen geçerli bir telefon numarası girin.',
    invalidEmail: 'Geçerli bir e-posta adresi girin.',
    fillAllFields: 'Lütfen tüm alanları doldurun.',
    mustAccept: 'Devam edebilmek için tüm sözleşmeleri kabul etmelisiniz.'
  },
  
  apply: {
    title: 'Tercüman Başvuru Formu',
    name: 'Ad',
    surname: 'Soyad',
    email: 'E-posta',
    phone: 'Telefon',
    password: 'Şifre (en az 8 karakter, büyük/küçük harf, rakam ve sembol)',
    education: 'Eğitim Durumu',
    highschool: 'Lise',
    bachelor: 'Lisans',
    university: 'Üniversite Adı',
    department: 'Bölüm',
    experience: 'Deneyim (Yıl / Açıklama)',
    languages: 'Bildiğiniz Diller (virgülle ayırın)',
    cv: 'CV Yükle (PDF veya DOC)',
    certificate: 'Sertifika Yükle (PDF, PNG, JPG)',
    submit: 'Başvuru Gönder',
    invalidEmail: 'Geçerli bir e-posta giriniz.',
    invalidPassword: 'Şifreniz en az 8 karakter, büyük/küçük harf, sayı ve sembol içermelidir.',
    success: 'Başvurunuz başarıyla alındı.',
    error: 'Başvuru gönderilirken bir hata oluştu.'
  },
  translators: {
    title: "Tercümanlar",
    subtitle: "Alanında uzman tercümanlarımız",
    completedJobs: {
        title: 'Tamamlanan İşler',
        headers: {
          jobCode: 'İş Kodu',
          file: 'Dosya',
          description: 'Açıklama',
          deliveryDate: 'Teslim Tarihi',
          output: 'Çıktı Dosyası',
          uploadDate: 'Yüklenme Zamanı',
          customer: 'Müşteri',
          specialization: 'Uzmanlık'
        }
    }
  },

  contact: {
    title: "Bizimle İletişime Geçin",
    subtitle: "Her türlü soru, görüş ve talepleriniz için bize ulaşabilirsiniz.",
    name: "Adınız Soyadınız",
    email: "E-posta Adresiniz",
    message: "Mesajınız",
    send: "Gönder",
    infoTitle: "İletişim Bilgileri"
  },

  login: {
    title: "Giriş Yap",
    email: "E-posta",
    password: "Şifre",
    button: "Giriş Yap",
    noAccount: "Hesabınız yok mu?",
    register: "Kayıt Ol",
    error: "E-posta veya şifre hatalı.",
    serverError: "Sunucu hatası oluştu.",
    forgotPassword: "Şifremi Unuttum",
  },
  cta: {
    title: "Dosyanızı yükleyin:",
    subtitle: "Tercümanlarımız siparişlerin çoğunu 20 dakika içinde başlatır!",
    uploadNow: "ŞİMDİ BELGENİ YÜKLE",
    contact: "İLETİŞİME GEÇİN",
    contactMessage: "Merhaba, belge vermeyi düşünüyorum. Bilgi almak istiyorum."
  },

  resetPassword: {
    title: 'Yeni Şifre Belirle',
    label: 'Yeni Şifreniz',
    button: 'Şifreyi Güncelle',
    loading: 'Güncelleniyor...',
    error: 'Bir hata oluştu.',
    success: 'Şifreniz başarıyla güncellendi.',
    emailSent: 'Şifre sıfırlama bağlantısı e-posta adresinize gönderildi.',
    invalid: 'Token geçersiz veya süresi dolmuş.',
    successRedirect: "Şifreniz başarıyla sıfırlandı. Giriş sayfasına yönlendiriliyorsunuz...",
    weakPassword: 'Şifre en az 8 karakter, bir büyük harf, bir küçük harf, bir rakam ve bir özel karakter içermelidir.'
  },
  offeredJobs: {
      title: 'Teklif Verdiklerim'
    },
    languages: 'Diller',
    offerPrice: 'Teklif Fiyatı',
    offerDeliveryDate: 'Teklif Teslim Tarihi',  

  verifyEmail: {
    successTitle: 'E-posta Doğrulandı!',
    successMessage: 'Hesabınız başarıyla doğrulandı.',
    expiredTitle: 'Bağlantı Süresi Doldu',
    expiredMessage: 'Doğrulama bağlantısının süresi dolmuş. Yeni bağlantı gönderebilirsiniz.',
    defaultTitle: 'E-posta Doğrulama',
    defaultMessage: 'Doğrulama bağlantısı kontrol ediliyor...',
    goLogin: 'Giriş Yap',
    didntWork: 'Bağlantı çalışmadı mı?',
    resend: 'Yeniden Gönder',
    sending: 'Gönderiliyor...',
    error: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    redirecting: "E-posta doğrulandı. Giriş sayfasına yönlendiriliyorsunuz...",
  },

  forgotPassword: {
    title: "Şifremi Unuttum",
    placeholder: "E-posta adresinizi girin",
    button: "Şifre Sıfırlama Bağlantısı Gönder",
    loading: "Gönderiliyor...",
    error: "Bir hata oluştu. Lütfen tekrar deneyin."
  },
  
},

en: {
  academic: "Academic",
  actions: 'Actions',
  active: "Active",
  allHatTypes: "All Hat Types",
  apostille_translation: "Apostille Certified Translation",
  back: "Back",
  cancel: 'Cancel',
  close: 'Close',
  complete: 'Complete',
  completeJob: 'Complete Job',
  completed: "Completed",
  completionFailed: 'Job completion failed.',
  confirmDelete: 'Are you sure you want to delete this file?',
  customer: "Customer",
  delete: 'Delete',
  deleteFailed: 'File deletion failed.',
  delivery: "Delivery",
  deliveryDate: 'Delivery Date',
  deliveryNearest: "Nearest Delivery Date",
  delivery_date_label: "When should it be delivered?",
  desc: "Description",
  description: 'Description',
  details: "Job Details",
  document_description: "Document name or description",
  edit: 'Edit',
  email: "E-mail",
  file: 'File',
  fileDeleted: 'File deleted.',
  filenameAsc: "Filename A-Z",
  filenameDesc: "Filename Z-A",
  general: "General",
  hatType: "Script Type",    
  jobCode: "Job Code",    
  jobCompleted: 'Job completed successfully.',
  job_code: "Job Code",
  jobs: 'Jobs',
  langPlaceholder: "Search language...",
  langs: "Languages",
  language: 'Language',
  legal: "Legal",
  loading: 'Loading...',
  medical: "Medical",
  new_translation_request: "Create New Translation Request",
  next: "Next",
  noData: 'No data found',
  noFileSelected: 'No file selected.',
  noOutputYet: 'None yet',
  none: "None",
  notary_translation: "Notarized Translation",
  offer: "Give Offer",
  official_document_translation: "Official Document Translation",
  openJobs: "Open Jobs",
  outputFile: 'Output File',
  outputUploaded: 'Output file uploaded.',
  outputs: 'Outputs',
  page: "Page",
  paid: "Paid",
  pay_now: "Pay Now",
  payment: 'Payment',
  pending: "Pending",
  price: 'Price',
  priceAsc: "Price Ascending",
  priceDesc: "Price Descending",
  request_revision: "Request Revision",
  searchPlaceholder: "Search job or customer...",
  selectSourceLang: 'Select Source Language',
  selectTargetLang: 'Select Target Language',
  select_calligraphy_type: "Select Calligraphy Type",
  select_source_language: "Select Source Language",
  select_specialization: "Select Specialization",
  select_target_language: "Select Target Language",
  select_translation_type: "Select Translation Type",
  sortNone: "No Sorting",
  specialization: "Specialization",
  status: 'Status',
  submit: 'Submit',
  submitOffer: "Submit Offer",
  sworn_translation: "Sworn Translation",
  technical: "Technical",
  translationType: "Translation Type",   
  translator: 'Translator',
  upload: 'Upload',
  uploadDocument: 'Upload Document',
  uploadFailed: 'Upload failed.',
  uploadTime: 'Upload Time',
  upload_document: "Upload Document",
  your_jobs: "Your Jobs",
  welcome: 'Welcome',

  nav: {
    home: 'Home',
    about: 'About',
    contact: 'Contact',
    translators: 'Translators',
    login: 'Login',
    logout: 'Logout',
    panel: 'Panel',
    settings: 'Settings',
    quote: "Translation Quote",
    apply: "Translator Application",
    services: "Services",
    official: "Official Document Translation",
    sworn: "Sworn Translation",
    notary: "Notarized Translation",
    apostille: "Apostilled Translation",
    warning: "Only users can request a translation quote on this page. Please create a user account to proceed.",
    welcome: "Welcome! Redirecting you..."
  },

  assignedJobs: {
    title: 'Assigned Jobs'
  },
  translatorPanel: {
    welcome: 'Welcome, {name}!',
    tabs: {
      assigned: 'Assigned Jobs',
      open: 'Open Jobs',
      offered: 'My Offers',
      completed: 'Completed Jobs'
    },
    table: {
      jobCode: 'Job Code',
      file: 'File',
      desc: 'Description',
      deliveryDate: 'Delivery Date',
      outputFile: 'Output File',
      uploadTime: 'Upload Time',
      customer: 'Customer',
      actions: 'Actions',
      specialization: 'Specialization',
      edit: 'Edit',
      completeJob: 'Complete Job',
      delete: 'Delete',
      noOutputYet: 'Not Available Yet'
    },
    loading: 'Loading...'
  },  
   
  hero: {
    title1: "Break Language Barriers",
    title2: "Professional Translation Service",
    title3: "Reliable and Fast Delivery",
    title4: "Your Documents Are Safe With Us",
    subtitle: 'Get fast and reliable translation from professional translators.',
    subtitle2: 'Meet our expert translators in every language.',
    subtitle3: "Timely, high-quality, and affordable translations.",
    subtitle4: "Your documents are kept safe and confidential.",
    contactButton: "Contact Us"
  },

  services: {
    title: "Our Services",

    official: {
      title: "Official Document Translation",
      description: "Your official documents (passport, diploma, ID, etc.) are translated by our expert translators in accordance with legal and formal standards. We guarantee that your documents will be accepted by official institutions.",
      button: "Submit Document"
    },

    sworn: {
      title: "Sworn Translation",
      description: "Sworn translation is performed, signed, and sealed by translators authorized by the courts. These translations are legally valid and recognized in official procedures.",
      button: "Submit Document"
    },

    notary: {
      title: "Notarized Translation",
      description: "The document translated by a sworn translator is submitted to a notary for official certification. This service is especially preferred for official applications within the country.",
      button: "Submit Document"
    },

    apostille: {
      title: "Apostille Certified Translation",
      description: "An apostille is an international certification required for documents to be valid abroad. Your document is translated, then certified by a notary and apostilled by the district governor's office.",
      button: "Submit Document"
    },

    revision: {
      title: "Translation Revision",
      description: "If there are any mistakes or omissions in your translation, you can request a free revision. Your satisfaction is our top priority.",
      button: "Request Revision"
    },

    notifications: {
      title: "Notification Support",
      description: "Stay informed at every step of your translation process. Enable notifications to easily follow offers, approvals, and deliveries.",
      button: "Enable Notifications"
    }
  },

  howItWorks: {
    title: 'How It Works',
    upload: 'Upload Document',
    uploadDesc: 'Upload your file for translation.',
    offer: 'Receive Offers',
    offerDesc: 'See offers from our translators.',
    pay: 'Make Payment',
    payDesc: 'Choose the best offer and make your payment.',
    receive: 'Download Translation',
    receiveDesc: 'Your translation will be ready to download.'
  },

  testimonials: {
    title: 'Customer Testimonials',
    comment1: 'The service was fast and high-quality. I received my document on time. Will definitely work again.',
    name1: 'Ahmet Yılmaz',
    comment2: 'They translated my document the same day. Communication was easy and the process went smoothly.',
    name2: 'Elif Demir',
    comment3: 'Great value for money. I received excellent service. Highly recommend.',
    name3: 'Burak K.',
    comment4: 'Thank you for the attentive customer support and professional translation service.',
    name4: 'Zeynep A.'
  },

  footer: {
    contact: "Contact",
    chat: "Chat with us",
    services: "Our Services",
    service1: "Official Document Translation",
    service2: "Sworn Translation",
    service3: "Notarized Translation",
    service4: "Apostille Translation",
    service5: "Translation Quote",
    company: "Company",
    about: "About Us",
    careers: "Careers",
    social: "Social Media",
    rights: "All rights reserved"
  },

  register: {
    title: 'Register',
    name: 'First Name',
    surname: 'Last Name',
    birthDate: 'Date of Birth',
    phone: 'Phone Number',
    email: 'Email',
    password: 'Password',
    passwordRule: 'Password must be at least 8 characters, contain uppercase, lowercase, number and symbol.',
    agreeText: 'I agree to the <terms>User Agreement</terms> and <privacy>Privacy Policy</privacy>.',
    terms: 'User Agreement',
    privacy: 'Privacy Policy',
    termsText: 'I accept.',
    privacyText: 'I accept.',
    alreadyHaveAccount: 'Already have an account?',
    registerButton: 'Register',
    goLogin: 'Login',
    mustBeOver18: 'You must be over 18 years old.',
    invalidPhone: 'Please enter a valid phone number.',
    invalidEmail: 'Please enter a valid email address.',
    fillAllFields: 'Please fill in all fields.',
    mustAccept: 'You must accept all agreements to proceed.'
    },

  apply: {
    title: 'Translator Application Form',
    name: 'First Name',
    surname: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    password: 'Password (min. 8 chars, upper/lower, number & symbol)',
    education: 'Education Level',
    highschool: 'High School',
    bachelor: 'Bachelor\'s Degree',
    university: 'University Name',
    department: 'Department',
    experience: 'Experience (Years / Description)',
    languages: 'Languages you speak (comma separated)',
    cv: 'Upload CV (PDF or DOC)',
    certificate: 'Upload Certificate (PDF, PNG, JPG)',
    submit: 'Submit Application',
    invalidEmail: 'Please enter a valid email address.',
    invalidPassword: 'Password must be at least 8 characters and include uppercase, lowercase, number, and symbol.',
    success: 'Your application was submitted successfully.',
    error: 'An error occurred while submitting your application.'
  },
    
  translators: {
    title: "Translators",
    subtitle: "Our expert translators",
    completedJobs: {
        title: 'Completed Jobs',
        headers: {
          jobCode: 'Job Code',
          file: 'File',
          description: 'Description',
          deliveryDate: 'Delivery Date',
          output: 'Output File',
          uploadDate: 'Uploaded At',
          customer: 'Customer',
          specialization: 'Specialization'
        }
      }
  },
  
  contact: {
    title: "Contact Us",
    subtitle: "Feel free to reach out to us with any questions or requests.",
    name: "Your Full Name",
    email: "Your Email Address",
    message: "Your Message",
    send: "Send",
    infoTitle: "Contact Information"
  },

  login: {
    title: "Login",
    email: "Email",
    password: "Password",
    button: "Login",
    noAccount: "Don't have an account?",
    register: "Register",
    error: "Email or password is incorrect.",
    serverError: "Server error occurred.",
    forgotPassword: "Forgot Password?",
    
  },

  cta: {
    title: "Upload your document:",
    subtitle: "Our translators start most orders within 20 minutes!",
    uploadNow: "UPLOAD NOW",
    contact: "CONTACT US",
    contactMessage: "Hello, I'm considering submitting a document. I'd like more information."
  },

  resetPassword: {
    title: 'Set New Password',
    label: 'Your New Password',
    button: 'Update Password',
    loading: 'Updating...',
    error: 'An error occurred.',
    success: 'Your password has been successfully updated.',
    emailSent: 'Password reset link has been sent to your email.',
    invalid: 'The token is invalid or has expired.',
    successRedirect: "Your password has been reset successfully. Redirecting to login page...",
    weakPassword: 'Password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special character.'
  },

  verifyEmail: {
    successTitle: 'Email Verified!',
    successMessage: 'Your account has been successfully verified.',
    expiredTitle: 'Link Expired',
    expiredMessage: 'The verification link has expired. You can request a new one.',
    defaultTitle: 'Email Verification',
    defaultMessage: 'Checking the verification link...',
    goLogin: 'Go to Login',
    didntWork: 'Did the link not work?',
    resend: 'Resend Email',
    sending: 'Sending...',
    error: 'An error occurred. Please try again.',
    redirecting: "Email verified. Redirecting to login page...",
  },

  forgotPassword: {
    title: "Forgot Your Password?",
    placeholder: "Enter your email address",
    button: "Send Reset Link",
    loading: "Sending...",
    error: "An error occurred. Please try again."
  },
  offeredJobs: {
      title: 'My Offers'
    },
    languages: 'Languages',
    offerPrice: 'Offer Price',
    offerDeliveryDate: 'Offer Delivery Date',

  }
}
